var icon = require('vue-svgicon')
icon.register({
  'ionicons/ios-play-outline': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M144 124.9L353.8 256 144 387.1V124.9M128 96v320l256-160L128 96z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/generated_svg_icons/ionicons/ios-play-outline.js